import clsx from 'clsx';
import { DropdownItem } from 'components/UI/V3/Dropdown/Item/DropdownItem';
import React from 'react';
import styles from './DropdownGroup.module.scss';

interface DropdownGroupProps {
    title: string;
    children?: React.ReactNode;
    className?: string;
}

export const DropdownGroup: React.FC<DropdownGroupProps> = ({ title, children, className }) => {
    return (
        <div className={clsx(styles.root, className)}>
            <DropdownItem className={styles.title}>{title}</DropdownItem>

            <div className={styles.content}>{children}</div>
        </div>
    );
};
